import { abortIfNotPermitted } from '../../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "stock-transfer" */ '@js/franchise_component/franchise-inventory/stock-transfer/stock-transfer-index.vue'),
        // beforeEnter: (to, from, next) => {
        //     return abortIfNotPermitted(
        //         'franchise_view_inventory_stock_transfer',
        //         next,
        //     );
        // },
    },
    {
        path: '/out/create',
        component: () =>
            import(/* webpackChunkName: "transfer-out-create" */ '@js/franchise_component/franchise-inventory/stock-transfer/transfer-out/transfer-out-create.vue'),
        // beforeEnter: (to, from, next) => {
        //     return abortIfNotPermitted(
        //         'franchise_manage_inventory_stock_return',
        //         next,
        //     );
        // },
    },
    {
        path: '/out/:id',
        component: () =>
            import(/* webpackChunkName: "transfer-out-edit" */ '@js/franchise_component/franchise-inventory/stock-transfer/transfer-out/transfer-out-edit.vue'),
        // beforeEnter: (to, from, next) => {
        //     return abortIfNotPermitted(
        //         'franchise_view_inventory_stock_return',
        //         next,
        //     );
        // },
    },
    {
        path: '/in/:id',
        component: () =>
            import(/* webpackChunkName: "transfer-in-edit" */ '@js/franchise_component/franchise-inventory/stock-transfer/transfer-in/transfer-in-edit.vue'),
        // beforeEnter: (to, from, next) => {
        //     return abortIfNotPermitted(
        //         'franchise_view_inventory_stock_return',
        //         next,
        //     );
        // },
    },
];
